(function () {
  'use strict';

  angular
    .module('corePermissoes')
    .run(run);

  const MOMENT_LOCALE_BY_IDIOMA = {
    pt_br: 'pt-br',
    es_es: 'es',
    en_us: 'en',
    en_gb: 'en-gb',
    de_de: 'de',
    fr_fr: 'fr',
    it_it: 'it',
    nl_nl: 'nl',
    pl_pl: 'pl'
  };

  function run($rootScope, $translate, dateRangePickerConfig, moment) {
    dateRangePickerConfig.timePicker = true;
    dateRangePickerConfig.timePicker12Hour = false;

    function applyLocale(idioma) {
      moment.locale(MOMENT_LOCALE_BY_IDIOMA[idioma] || 'en');
      const localeData = moment.localeData(),
            ranges = {};

      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.today')] =
        [moment().startOf('day'), moment().endOf('day')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.yesterday')] =
        [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.last7Days')] =
        [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.last30Days')] =
        [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')];

      dateRangePickerConfig.ranges = ranges;
      dateRangePickerConfig.locale = {
        format: 'DD/MM/YYYY HH:mm',
        separator: ' - ',
        applyLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.applyLabel'),
        cancelLabel: $translate.instant('core-permissoes.organizacao.common.cancel'),
        fromLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.fromLabel'),
        toLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.toLabel'),
        weekLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.weekLabel'),
        customRangeLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.customRangeLabel'),
        daysOfWeek: localeData.weekdaysShort(),
        monthNames: localeData.months(),
        firstDay: localeData.firstDayOfWeek()
      };
    }

    applyLocale($translate.use());
    $rootScope.$on('$translateChangeSuccess', (event, data) => applyLocale(data.language));
  }
}());
